<template>
 <div>
   <div class="login-commont">
     <div class="backdiv">
         <p @click="gogw"><i class="icon el-icon-arrow-left"></i>{{$t('global.back')}}</p>
     </div>
   <div class="header-top">
      <div class="index_tishi">
          <span > {{tishi}} </span>
        </div>
     <img
        class="logo"
        src="../assets/classovernew.png" @click="gogw">

   </div>
		<div class="hr-form">
			<div class="form">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
					<h3> {{$t('Sign in')}} </h3>
					<div class="selectdiv">
						<span @click="chcode" :class="code?'oncss':''"> {{ $t('Verification Code')}} </span>
						<span @click="chpass" :class="pass?'oncss':''">{{ $t('Passwordon')}} </span>
					</div>
					<el-form-item  prop="phone">
						<el-input  oninput="value=value.replace(/\D/gi,'')" :placeholder="$t('Phone number')" v-model="ruleForm.phone" :maxlength="max" class="wp-input input-with-select">
							<el-select v-model="ruleForm.countryIndex" slot="prepend" style="width: 120px" @change="changeCode"  >
							  <div class="el-input_search">
                <img src="../assets/search.svg" />
                  <input type="text"
                        :placeholder="$t('signIn.searchArea')"
                        class="el-input__inner"
                        v-model="dropDownValue"
                        @keyup="dropDownSearch">
              </div>

              	<el-option v-for="(item, index) in countries" :label="`+${item.country_code } ${ item.name} `" :key="item.id" :value="item.id">
									<span>+{{item.country_code }} {{ item.name }}  </span>
								</el-option>
							</el-select>
						</el-input>
					</el-form-item>

					<el-form-item   v-if="code"  prop="verification" class="wp-item" >
							<el-input  maxlength="6"  :placeholder="$t('Verification code')" v-model="ruleForm.verification" oninput="value=value.replace(/\D/gi,'')" class="wp-input input-with-send">

								<el-button slot="append"  @click="countDown">
									 <span v-if="maxTotaltime == setTime"> {{$t('Send')}} </span>
									 <span v-else>{{setTime}} s </span>
								</el-button>
							</el-input>
					</el-form-item>

					<div v-if="code" class="bytwo">
						<el-button class="wp-button primary" @click="verifyClick">{{ $t('Continue') }}</el-button>
					</div>

					<el-form-item  v-if="pass"  prop="password" class="wp-item" >
							<el-input   :type="flagType"   :placeholder="$t('Password')" v-model="ruleForm.password" class="wp-input input-with-send input-with-pass">
								<img @click="getFlag()" slot="suffix" :src="flag ? see:nosee" style="margin-top:20px;font-size:18px;cursor:pointer;padding-right:15px;width:14px;height:10px;" alt="">
							</el-input>
					</el-form-item>

					<div v-if="pass" class="bytwo">
						<el-button class="wp-button primary" @click="submitForm()">{{ $t('Continue') }}</el-button>
					</div>

					<div class="byone">
						<span class="message">{{ $t('By continuing, you agree to our Terms of Use and Privacy Policy.') }}</span>
					</div>
				</el-form>

			</div>
      <p class="topricing">{{$t("Dont have an account")}} <a :href="url+'/pricing/onlineFreeClass?utm_id=17'">{{$t('Sign up to get a free lesson')}} </a></p>
		</div>


		</div>
    <img class="login1" src="../assets/login1.png" alt="">
    <img class="login2" src="../assets/login2.png" alt="">
    <img class="login3" src="../assets/login3.png" alt="">
    <img class="login4" src="../assets/login4.png" alt="">
    <img class="login5" src="../assets/login5.png" alt="">
    <img class="login6" src="../assets/login6.png" alt="">
    <img class="login7" src="../assets/login7.png" alt="">
    <img class="login8" src="../assets/login8.png" alt="">
	</div>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
export default {
  name: 'loginPassword',
  data () {
    // 手机号验证
    const loginCheck = async (rule, value, callback) => {
      let reg = /^\d{1,}$/
      if (value.length < 1) {
        this.changeLoginFlag = 2
        return callback(new Error(this.$t('errorprompt.phoneEmpty')))
      } else if (!reg.test(value)) {
        this.changeLoginFlag = 2
        return callback(new Error(this.$t('errorprompt.phoneError')))
      } else {
        this.changeLoginFlag = 1
        callback()
      }
    }
    return {
      qvhao: [],
      areaCodeData: [],
      dropDownValue: '',
      valueMeta: [],
      ruleForm: {
        phone: '',
        password: '',
        // areaCode: '',
        pwdType: 'password',
        seen: false,
					countryIndex: '',//区号
					code:'',
					verification:'',//验证码
					password:'',//密码
      },
      resetForm: {
        newPassword: '',
        ConfirmNewPassword: '',
        NewSeen: false,
        confirmNewSeen: false,
        newPwdType: 'password',
        confirmNewPwdType: 'password'
      },
      rules: {
					phone: [
						{ required: true,  validator: loginCheck, trigger: 'blur' },
						{ min:6, message: this.$t('errorprompt.phoneError'), trigger: 'blur' },
					],
					verification:[
						{ required: true, message: this.$t('Please enter the verification code'), trigger: 'blur'  },
						{ max:6,min:6, message: this.$t('The verification code format is incorrect'), trigger: 'blur' },
					],
					password:[
						{required:true,message: this.$t('Please enter the password'), trigger: 'blur' }
					]
				},
      changeLoginFlag: 1,
      changeAgainFlag: 1,
      // openeye: require('@/assets/eye.svg'), // 图片地址
      // nopeneye: require('@/assets/eye-off.svg'), // 图片地址
      // pasteResult: [], // 存放粘贴进来的数字
      // 验证码倒计时
      maxTotaltime: 60,
      setTime: 60,
      timer: null,
      inputcode: '',
      // code: '',
      // 模块判断
      tishi:'', //浏览器提示
      max:10,
      time:0,
      code:true,
      pass:false,
      flag: false,
      flagType:'password',
      countries:[],
      see:require('../assets/nosee.png'),
				nosee:require('../assets/see.png'),
        url:window.location.origin,
    }
  },
  computed: {
  },
  created () {
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/sinadd'
        })
      } else {
        this.$router.push({
          path: '/home/children/AttendClassNow'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
    }
    this.getCountryCode()
    function gethtmlfontsize(){
				// 三个步骤:
				// 1.获取html的高,
				let htmlheight=document.documentElement.clientHeight || document.body.clientHeight;//有些浏览器documentElement获取不到,那就使用后面的body
				console.log( htmlheight);
				// 2.htmlDom
				let htmlDom=document.getElementsByTagName("html")[0]
				// console.log(htmlDom);
				//3.设置根元素样式
				htmlDom.style.fontSize=10* htmlheight/375+'px';
				console.log(htmlDom.style.fontSize)
				htmlDom.style.height = '100%';
			}
				// 调用一次
				gethtmlfontsize();
				// 添加监听事件(resize是监听的意思)
				window.addEventListener('resize',gethtmlfontsize)
  },
  mounted(){

      var userAgent =navigator.userAgent;
      var Chrome=userAgent.indexOf('Chrome') > -1;
      var Edge =userAgent.indexOf('Edg')>-1;
      if(!(Chrome||Edge)){
        this.tishi=this.$t('Please use');

      }
  },
  methods: {
     getFlag(){
			this.flag = !this.flag
			this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
			},
			chcode(){
				this.code=true;
				this.pass=false;
				this.$refs.ruleForm.resetFields();
			},
			chpass(){
				this.code=false;
				this.pass=true;
				this.$refs.ruleForm.resetFields();
			},
    changeCode(){
        this.countries.map((item) => {
            if(this.ruleForm.countryIndex == item.id){
                this.ruleForm.code = item.country_code
            }
        });
        if(this.ruleForm.code=='86'){
			if(this.ruleForm.phone.length>11){
				this.ruleForm.phone = ''
			}
          this.max = 11
        }else if(this.ruleForm.code=='1'){
          if(this.ruleForm.phone.length>10){
            this.ruleForm.phone = ''
          }
          this.max = 10
        }else{
			this.max= 15
		}
      },
    gogw:function(){
       if(process.env.NODE_ENV === 'production'){
      window.location.href='https://classover.com/en/';
    }
    else if( process.env.NODE_ENV === 'development') {
      window.location.href='https://classover.com/en/';
    }
    },
    // 国家区号
    getCountryCode () {
      this.$http.get('/api/dict/countries?page=1&pagesize=999&keywords=&country_code=').then((res) => {
        console.log(111111111,res)
        this.countries = res.data.data.map((item) => {
					return { id: item.id, name: item.title, country_code: item.country_code };
				});
        this.qvhao = this.countries
        // this.areaCodeData = res.data.data
        setStore(keys.areaCodeList,res.data.data)
        this.ruleForm.countryIndex = this.countries[0].id
        this.ruleForm.code=this.countries[0].country_code
      })
    },
    dropDownSearch () {
      var _this = this
      if (_this.dropDownValue) {
        _this.countries = []
        _this.qvhao.find(item => {
          let name =  ' +' + item.country_code + item.name
          if (name.toLowerCase().indexOf(_this.dropDownValue.toLowerCase()) != -1) {
            _this.countries.push(item)
          }
        })
      } else {
        _this.countries = _this.qvhao
      }
    },
    toPassword () {
      this.$router.push({ path: '/loginPassword' })
    },
    toNext () {

    },

    // 验证码登录
    verifyClick() {
      this.$refs.ruleForm.validate((valid, msg) => {
        if (!valid) {
          this.$message(msg['phone'][0].message)
          return false
        }
        this.$http.post('/api/verifyCode', {
          mobile: this.ruleForm.phone,
          code:this.ruleForm.verification ,
          country_code: this.ruleForm.code
        }).then((res) => {
          if (res.data.code == 200) {
            console.log(res)
            this.$http.post('/api/verify-code-login', {
              mobile: this.ruleForm.phone,
              code: this.ruleForm.verification,
              country_code: this.ruleForm.code,
              time_zone: this.utils.getTimeZoneCity(),
              utm_source :'pc'
            }).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                setStore(keys.userInfo, res.data.data);

                setStore(keys.token,res.data.data.token)
                let time_zone = this.utils.getTimeZoneCity()
                this.$http.get('/api/intercomUser?time_zone='+time_zone).then((res) => {
                  if (res.data.code == 200) {
                    console.log(res)
                    setStore(keys.IntercomUser, res.data.data)
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: 'warning'
                    })
                  }
                }).catch((error) => {
                  console.log(error) // 请求失败返回的数据
                })
                this.$http.post('/api/checkUser', {
                mobile:this.ruleForm.phone,
                country_code:this.ruleForm.code
              }).then((body) => {
                if(body.data.code==200){
                  if(body.data.data.status==0){
                    console.log('wewe')
                     this.$router.push({ path: '/sinadd' })
                    // this.$router.push({
                    //   name: 'add',
                    //   params: {
                    //   },
                    // });
                  }
                  else{
                    this.$router.push({ path: '/home/children/AttendClassNow' })
                  }
                }})
                // setTimeout(() => {
                //   if (res.data.data.status == 0) {
                //     this.$router.push({ path: '/email' })
                //   } else {
                //     this.$router.push({ path: '/home/children/AttendClassNow' })
                //   }
                // }, 2000)
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      })
    },
    submitForm() {
			    this.$refs.ruleForm.validate ((valid) => {
					if(valid){
            this.$http.post('/api/login', {
          mobile: this.ruleForm.phone,
          password: this.ruleForm.password,
          country_code: this.ruleForm.code,
          time_zone: this.utils.getTimeZoneCity()
        }).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.userInfo, res.data.data)
            setStore(keys.token,res.data.data.token)
            let time_zone = this.utils.getTimeZoneCity()
            this.$http.get('/api/intercomUser?time_zone='+ time_zone).then((res) => {
              if (res.data.code == 200) {
                setStore(keys.IntercomUser, res.data.data)
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
            setTimeout(() => {
              if (res.data.data.status == 0) {
                // this.$router.push({ path: '/email' })
              } else {
                this.$router.push({ path: '/home/children/AttendClassNow' })
              }
            }, 2000)
          } else {
            if(res.data.msg=='Password input error'){
              this.$message({
                message: this.$t('Wrong password'),
                type: 'error',
                customClass:'dismessageclass',
              })
            }
            else{
               this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
            }
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })

					}
				});


			},
    // 倒计时
    setCount (setTime) {
      if (setTime >= 0) {
        if (!this.timer) {
          this.timer = setInterval(() => {
            if (this.setTime > 0 && this.setTime <= this.maxTotaltime) {
              this.setTime--
            } else {
              clearInterval(this.timer)
              this.timer = null
              this.setTime = 60
            }
          }, 1000)
        }
      }
    },
    countDown () {//发送验证码
      if (!this.ruleForm.phone) {
        this.$message({
          message: this.$t('errorprompt.phoneEmpty'),
          type: 'warning'
        })
        return false
      }
      if (this.maxTotaltime == this.setTime) {
        if (this.changeLoginFlag == 1) {
           this.$http.post('/api/checkUser', {
                mobile:this.ruleForm.phone,
                country_code:this.ruleForm.code
              }).then((body) => {
                if(body.data.code==200){
                  if(body.data.data.is_exist==0){
                    // this.$router.push({
                    //   name: 'newUser',
                    //   params: {
                    //     phone: this.ruleForm.phone,
                    //     country_code: this.ruleForm.code,
                    //   },
                    // });
                    this.$message({
                      message: this.$t('User Does Not Exist'),
                      type: 'warning',
                      customClass:'messageclass',
                      //   center: true
                    });
                    return false
                  }
                  this.$http.post('/api/login/verify-code', {
                  mobile: this.ruleForm.phone,
                  length: 6,
                  country_code: this.ruleForm.code
                }).then((res) => {
                  if (res.data.code == 200) {
                      this.setCount(this.setTime)
                    console.log(res)

                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: 'warning'
                    })
                  }
                }).catch((error) => {
                  console.log(error) // 请求失败返回的数据
                })
                 // this.code = res.data.data.code
                }
              })

        }
      }
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.topricing{
  font-family: Sofia Pro-Semi-Bold;
font-style: normal;
font-weight: 500;
font-size: 18px;
line-height: 20px;
text-align: center;
font-feature-settings: 'salt' on;
color: #000000;
  a{
    color: #1e22fb;
  }
}
.login1{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 56rem;
  height: 24rem;
}
.login2{
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18rem;
}
.login3{
  position: absolute;
  top: 4.7rem;
  left: 3rem;
  width: 2rem;
}
.login4{
  position: absolute;
 top: 6.5rem;
  left: 1rem;
  width: 1rem;
}
.login5{
  position: absolute;
  top: 8.5rem;
  left: 6rem;
  width: 1.5rem;
}
.login6{
  position: absolute;
  top: 4rem;
  right: 6rem;
  width: 1rem;
}
.login7{
  position: absolute;
  bottom: 15rem;
  right: 1.5rem;
  width: 2.5rem;
}
.login8{
  position: absolute;
  bottom: 2rem;
  right: 28rem;
  width: 1.6rem;
}
.header-top{
  display: table;
  margin: 0 auto 0;
  // padding-top: 121px;
  // padding-top: 1rem;
  text-align: center;
  img{
    width: 12rem;
  }
  .index_tishi{
    width:22rem;
    height: 1.1rem;
    // margin: 0.8rem auto 0;
    padding-bottom:1.6rem;
    // border-bottom: 1px solid  #E5E7EB;
    font-family: 'Sofia Pro';
    font-style: normal;
    font-weight: 400;
    font-size:0.7rem;
    line-height: 1.1rem;
    font-feature-settings: 'salt' on;
    color: #374151;
    align-items: center;
    text-align: center;
  }
}

  .oncss{
		color: #000000;
	}
	.title {
		font-family: Sofia Pro Bold;
		font-style: normal;
		font-weight: 700;
		font-size: 28px;

		color: #111827;
		text-align: center;
		margin-top: 153px;
		span{
			display: block;
			line-height: 42px;
		}
	}
	.smail-title{
		font-family: 'Sofia Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: #6B7280;
		display: block;
		margin-top: 10px;
	}
	.hr-form{
		width:24rem ;
		margin: 0 auto;
		// margin-top:1.3rem;
		padding: 0.8rem  0.8rem 0;
		// border-top: 1px solid  #E5E7EB;
	}

	.form {
		// box-sizing:border-box;
		margin: 0px auto 0.8rem;
		width: 18rem;
		// height: 328px;
		background: #FFFFFF;
		box-shadow: 0px 1px 30px rgba(16, 24, 40, 0.1), 0px 1px 2px -1px rgba(16, 24, 40, 0.1);
		border-radius: 12px;
		padding: 1.3rem;
		input , span,/deep/.el-input__inner{
			font-family: 'Sofia Pro';
		}
		.selectdiv{
			font-weight: 500;
			font-size: 0.7rem;
			line-height: 1.1rem;
			color: #B4BAC3;
			display: flex;
			justify-content:space-between;
			margin-bottom: 0.8rem;
			span{
				font-family: 'Sofia Pro';
				cursor:pointer;
			}
		}
		h3{
			font-family:  Sofia Pro SemiBold;
			font-style: normal;
			font-weight: 600;
			font-size: 0.8rem;
			line-height: 1.1rem;
			color: #111827;
			text-align: center;
			margin: 0 auto 0.8rem;
		}
		.message {
			font-family: 'Inter';
			font-style: normal;
			font-weight: 400;
			font-size: 0.5rem;
			line-height: 0.8rem;
			display: block;
			text-align: center;
			margin: 1.3rem auto 0;
			color: #6B7280;
		}
		.empty{
			color: #F56C6C;
			font-size: 12px;
			line-height: 1;
			padding-top: 4px;
			position: absolute;
			top: 100%;
			left: 0;
		}
	}
	/deep/.wp-button{
		font-family: 'Inter';
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 28px;
		padding: 10px 20px;
	}
	.byone{
			// margin-top: 150px;
		}
		/deep/.el-input /deep/.el-input--suffix/deep/ .el-input__inner{
		color: #000000;
	}
  .bytwo{
     /deep/ .el-button{
        width: 100%;
        background: #4B4EFC;
        border-radius: 40px;
        // padding: 8px 20px;
        span{
          font-family: 'Inter';
          font-feature-settings: 'salt' on;
          font-style: normal;
          font-weight: 500;
          font-size: 0.7rem;
          line-height: 0.95rem;
          color: #FFFFFF;
        }
      }
  }


	@media screen and (max-width: 736px){
		.title{
			margin-top:37px;
			font-weight: 700;
			font-size: 20px;
			line-height: 36px;
			  color: #111827;
			  font-family: Sofia Pro Bold;
		}
		.smail-title{
			width: 335px;
			margin: 10px auto 0;

		}
		.hr-form{
			width: 90%;
			margin: 0 auto;
			margin-top:20px;
			padding:  0px;
			padding-top: 128px;
			// border-top: 1px solid  #E5E7EB;
			.form{
				width: 81%;
			}
	   }
	   .byone{
		margin-top: 32px;
	   }

		.bytwo{
			margin-top: 10px;
		}
		.bytwo /deep/.el-button--default {
			font-weight: 500;
           font-size: 18px;
            line-height: 28px;
			font-family: Sofia Pro SemiBold;
		}
		/deep/.el-input__inner{
			color: #667085;
		}
		.wp-input input-with-select{
			color: #101828;
		}
		/deep/.el-form-item{
			margin-top: 20px;
		}
	}
	/deep/.el-input.is-active .el-input__inner, /deep/.el-input__inner:focus{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.el-input-group__prepend:focus{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.el-input-group__prepend:focus-within{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.wp-input .el-input-group__prepend{
		border-radius: 6px 0 0 6px;
		// border-right: none;
	}
	/deep/.el-input-group__prepend{
		background: #FFFFFF;
	}
	/deep/.input-with-send {
		input{
			border-radius:6px 0  0 6px;
			// border-right:none;
		}
	}
	/deep/.input-with-pass{
		input{
			border-radius: 6px;
		}
	}
	/deep/.input-with-select{
		border-radius:0 6px   6px 0 ;
		.el-input__inner{
			// border-left: 0;
		}

	}

	/deep/.el-input__inner{
		border-radius:0 6px   6px 0 ;
    height: 44px;
	}
   /deep/.wp-item,/deep/.el-form-item__content{
	width: 100%;
	display: flex;
	flex-direction :row;
	// .wp-input{
	// 	width: 80%;
	// }

   }
   /deep/.wp-input{
	.el-input-group__append{
		background:  #FFFFFF;
		font-family: 'Sofia Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 22px;
		color: #4B69FE;

	}
   }
   /deep/.wp-input .el-input-group__append:focus-within{
	border: 1px  solid hsl(0, 0%, 0%);
   }
   /deep/ .wp-input .el-input-group__append:focus{
	border: 1px  solid hsl(0, 0%, 0%);
   }
 .el-input_search{
     .el-input__inner:focus,.el-input__inner{
       border: none;
     }
    /deep/.el-input__inner:focus{
      border: none;
    }

  }
   .backdiv{
      width: 100%;
      margin-top:2rem;
      margin-left: 3.8rem;
      // margin-bottom: 2rem;
      font-family: Sofia Pro-Semi-Bold;
font-style: normal;
font-weight: 500;
font-size: 0.7rem;
line-height: 1rem;
font-feature-settings: 'salt' on;
color: #5558FB;
i{
  margin-right: 0.8rem;
}
    }
@media screen and (min-width: 736px){
		.form .selectdiv{
			display: flex;
			justify-content:space-around;
		}
    .login-commont{
      height:100vh ;
      width: 100%;
      overflow: hidden;
      display: flex;
		flex-direction:column;
		// justify-content:center;
		align-items:center;
    position: absolute;
    // left: calc(50% - 12rem);
    z-index: 99999;
    }
    /deep/.el-input__inner{
      height: 1.7rem;
      font-size: 0.55rem;
    }
    /deep/.el-form-item{
      margin-bottom: 0.8rem;
    }
   /deep/ .el-input__icon{
      line-height: 2rem;
    }
	}

</style>



// WEBPACK FOOTER //
// src/components/loginVerifyCode.vue